module.exports = __webpack_public_path__ + "media/images/icons/outlined/youtube-f652293d30a2b735d5c58f5c7d3ec7eb.svg";